import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';

const storageKey = 'blockblasts.io-theme';
const themeOrder: Theme[] = ['light', 'dark'];
const isTheme = (value: string | null): value is Theme => value === 'light' || value === 'dark';

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => {
    if (typeof window === 'undefined') return 'dark';
    const stored = localStorage.getItem(storageKey);
    return isTheme(stored) ? stored : 'dark';
  });

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.dataset.theme = theme;
    localStorage.setItem(storageKey, theme);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => {
      const idx = themeOrder.indexOf(prev);
      const next = idx >= 0 ? themeOrder[(idx + 1) % themeOrder.length] : 'dark';
      return next;
    });

  return { theme, toggleTheme };
}
